import type * as React from 'react'
import { Checkbox } from '@/components/ui/Checkbox'
import type { FieldBinding } from './types'

interface CheckboxFieldProps<T extends object> extends FieldBinding<T> {
  label: React.ReactNode
  disabled?: boolean
}

export function CheckboxField<T extends object>({
  form,
  name,
  label,
  disabled,
}: CheckboxFieldProps<T>) {
  return (
    <label className="text-fg flex cursor-pointer items-center gap-2 text-base">
      <Checkbox
        id={name}
        checked={!!form.data[name]}
        onCheckedChange={(next) => form.setData(name, next as T[keyof T & string])}
        disabled={disabled}
      />
      {label}
    </label>
  )
}
